// Copyright 2020 Sorama B.V.
import { autoinject, transient } from "aurelia-framework";
import { MeasurementWorkflowModuleCatalog } from "catalogs/WorkflowModuleCatalog/MeasurementModuleCatalog";
import { IWorkflowModuleInstance } from "libraries/WorkflowFramework/Interfaces/IWorkflowModule";
import { ShellViewManager } from "modules/shell/App/ShellViewManager";
import { IProjectManagementService } from "services/Project/IProjectManagementService";

/*
 * MODULE OPERATION DESCRIPTION - TimelineModule
 * The timeline module gets the list of timeline entries from Project repositry and
 * renders it to the front end.
 */
@transient()
@autoinject
export class TimelineModule {
    constructor(
        private readonly shellviewManager: ShellViewManager,
        private readonly projectManagementService: IProjectManagementService
    ) {}

    public activateModule(moduleInstance: IWorkflowModuleInstance): void {}

    public editProject(): void {
        this.shellviewManager.openRightSideBar(MeasurementWorkflowModuleCatalog.ProjectManagementModule);
    }
    //#endregion
}
